// extracted by mini-css-extract-plugin
export default {"link":"ZnerhSYiD42ylQHGYxUG"};